/* unplugin-vue-components disabled */import { render } from "./feeRuleDetail.vue?vue&type=template&id=5fbf8819"
import script from "./feeRuleDetail.vue?vue&type=script&lang=js"
export * from "./feeRuleDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/e-bike/e-bike-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__